export default __webpack_public_path__ + "static/media/flokin.01436c72.jpg";